module.exports = __webpack_public_path__ + "img/balkon.8deb5dc4.jpg";